import { jsx as o } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentcolor",
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2.024 14.049c0 2.476 2.085 4.483 4.657 4.483l11.878.004c1.914 0 3.465-1.56 3.465-3.487 0-1.926-1.55-3.486-3.464-3.486h-.99c.392-1.762-.282-3.58-1.77-4.77-1.488-1.192-3.564-1.571-5.444-1-1.88.574-3.282 2.012-3.675 3.774-2.572 0-4.657 2.007-4.657 4.482"
      }
    )
  }
);
export {
  t as default
};
